import React, { useCallback, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { TransactionLine } from "../../../../docuclipper/DocuclipperTypes";
import {
  formikInput,
  isNullOrUndefined,
  useHasQbo,
} from "../../../../utils/utils";
import { ReduxState } from "../../../../redux";
import { useDispatch, useSelector } from "react-redux";
import { convertTlsToTable } from "./utils";
import moment from "moment";
import { Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AgTable from "./AgTable";
import { useTransactions } from "./hooks";
import { uniq } from "lodash";
import EditableText from "../../../Docuclipper/EditableText";
import {
  performBulkEdit,
  updateJob,
  updateJobTransaction,
} from "../../../../docuclipper/api";
import Select from "react-select";
import { getCategoriesAction } from "../../../../redux/reducers/Categories";
import { fetchPieChart } from "../../../../redux/reducers/TagRegexes";
import AgBulkTable from "./AgBulkTable";
import { EditableFieldRequiredText } from "../../../../utils/EditableField";
import {
  setTls,
  toggleLoading,
} from "../../../../redux/reducers/TransactionManager";
import { createAlert } from "../../../../redux/reducers/Alerts";
import { FormWithOverlay } from "../../../../utils/form-with-overlay";
import { Field } from "formik";
import * as Yup from "yup";
import ClipLoader from "react-spinners/ClipLoader";
import { useIsAdmin } from "src/utils/auth";

export const datefilterParamsYYYYMMDD = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    console.log('datefilterParamsYYYYMMDD', { filterLocalDateAtMidnight, cellValue });

    const dateAsString = cellValue;
    if (dateAsString === null) return -1;
    const cellDate = moment(dateAsString, "YYYY-MM-DD").toDate();
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
};

const CategoryCellRenderer = (props) => {
  const values = props.data;
  const {
    date,
    description,
    amount,
    documentId,
    fieldName,
    rowNumber,
    columnMapping,
    included,
    chunk,
    accountName,
  } = values;

  const { job } = useSelector((state: ReduxState) => state.JobData);

  const dispatch = useDispatch();
  const onSave = (newCategory) => {
    // dispatch(
    //   updateMetadataField(documentId, name, newValue, accountName, chunk)
    // );
    if (!job) {
      return;
    }

    updateJobTransaction(job.id, values.id, {
      editedCategory: newCategory,
    })
      // .then(() => dispatch(getCategoriesAction()))
      .then(() => dispatch(fetchPieChart()))
      .catch((err) => null);
  };

  return (
    <EditableFieldRequiredText
      value={props.value}
      onSave={onSave}
      placement={"left"}
    />
  );
};

export const AnalyzeTransactionsTable = () => {
  const { isAdmin, isSuperLogin } = useIsAdmin();

  const transactions = useTransactions();

  const { job } = useSelector((state: ReduxState) => state.JobData);
  const { tls, loading } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );
  const { categories: tlsCategories } = tls;
  const dispatch = useDispatch();

  const [filterValues, setFilterValues] = useState([]);

  const handleFilterChange = (selectedOptions) => {
    const values = selectedOptions.map((option) => option.value);
    setFilterValues(values);
  };

  const categories = uniq(transactions.map((x) => x.category));
  const [columnDefs, setColumnDefs] = useState<any[]>([]);

  const bulkEditHelper = (operation, transactionIds, params) => {
    if (!job) {
      return Promise.resolve();
    }
    dispatch(toggleLoading());
    return performBulkEdit({
      jobId: job.id,
      operation,
      params,
      transactionIds,
    })
      .then(({ transactions }) => {
        dispatch(toggleLoading());
        dispatch(setTls({ transactions, resetPages: false }));

        // dispatch(fetchTotals());
        // dispatch(fetchMfs());

        // dispatch(fetchJobDocuments());
        // dispatch(fetchTls());
        dispatch(
          createAlert({
            message: "Correction made successfully",
            timeout: 0,
            type: "success",
          })
        );
        // dispatch(setSelectedRowIds({}));
      })
      .catch((err) => {
        dispatch(toggleLoading());
        dispatch(
          createAlert({
            message: "Error making correction",
            timeout: 0,
            type: "error",
          })
        );
      });
  };

  React.useEffect(() => {
    setColumnDefs([
      {
        field: "account",
        filter: "agTextColumnFilter",
        sortable: true,
        flex: 1,
      },
      {
        field: "date",
        filter: "agDateColumnFilter",
        filterParams: datefilterParamsYYYYMMDD,
        sortable: true,
        flex: 1,
      },
      {
        field: "description",
        filter: "agTextColumnFilter",
        flex: 3,
        filterParams: {
          // pass in additional parameters to the Text Filter
        },
      },
      {
        field: "amount",
        filter: "agNumberColumnFilter",
        sortable: true,
        flex: 1,
        filterParams: {
          // pass in additional parameters to the Number Filter
        },
      },
      {
        field: "category",
        filter: "agSetColumnFilter",
        flex: 2,
        cellRenderer: CategoryCellRenderer,
        // this doesn't work, just set category upstream
        // valueGetter: (params) => {
        //   // console.log({ params });
        //   return params.data.editedCategory || params.data.category || "";
        // },

        // filter: "agSetColumnFilter",
        filterParams: {
          values: categories,
        },

        // cellRenderer: (params) => {
        //   return (
        //     <>
        //       <span className="mr-1">{params.data.category || ""}</span>
        //       <FontAwesomeIcon icon="edit" />
        //     </>
        //   );
        // },
        // onCellValueChanged: (event) => {
        //   // console.log("Cell value changed:", event.newValue);
        //   // console.log({ event });
        //   if (job) {
        //     updateJobTransaction(job.id, event.data.id, {
        //       editedCategory: event.newValue,
        //     })
        //       // .then(() => dispatch(getCategoriesAction()))
        //       .then(() => dispatch(fetchPieChart()))
        //       .catch((err) => null);
        //   }
        // },

        // cellEditorParams: {
        //   values: categories,
        // },
      },
    ]);
  }, [categories.length]);

  return (
    <>
      {loading && (
        <Row>
          <ClipLoader />
        </Row>
      )}
      <AgBulkTable
        renderBulkOps={(data, setSelectedRowsIds) => {
          return (
            <FormWithOverlay
              icon="edit"
              initialValues={{ category: "" }}
              validationSchema={Yup.object().shape({
                category: Yup.string().required(),
              })}
              renderFields={() => (
                <Field
                  className="ml-2"
                  type="text"
                  id="category"
                  component={formikInput}
                  name="category"
                />
              )}
              cta={"Update Category"}
              disabled={data.length === 0}
              onSave={(values) => {
                if (!job) {
                  return;
                }
                bulkEditHelper(
                  "updateCategory",
                  data.map((x) => x.id),
                  { category: values.category }
                ).then(() => {
                  dispatch(fetchPieChart());
                  if (setSelectedRowsIds) {
                    setSelectedRowsIds([]);
                  }
                });
              }}
            />
          );
        }}
        hasExport={isAdmin}
        rowData={transactions}
        columnDefs={columnDefs}
        width={"100%"}
        height={800}
      />
    </>
  );
};
